import {
  tradeDateRange,
  balancingAreaAuthority,
  oasisSnapshotIndicator,
} from '@/components/Ciso/BaseStore/CisoConfigs';

export default {
  dockConfig: {
    alignment: 'LEFT',
    visible: false,
  },
  dataTypeNameMapping: (dataTypeName) => {
    switch (dataTypeName) {
    case 'diversityBenefitUc': return 'Diversity Benefit';
    case 'netExportCapability': return 'Net Export Capability';
    case 'netImportCapability': return 'Net Import Capability';
    case 'insufficiencyAmount': return 'Insufficiency Amount';
    case 'insufficiencyPercentage': return 'Insufficiency %';
    case 'credit': return 'Credit';
    case 'changeLoadForecast': return 'Change in Load Forecast';
    case 'rampCap': return 'Ramping Capacity';
    case 'netLoadUncert': return 'Net-Load Uncertainty';
    case 'requirementAmount': return 'Requirement Amount';
    case 'testStatus': return 'Test Status Pass';
    default:
      return dataTypeName;
    }
  },
  searchFilterConfig: {
    tradeDateRange,
    balancingAreaAuthority: { ...balancingAreaAuthority, required: true, includeAllOption: false },
    oasisSnapshotIndicator: { ...oasisSnapshotIndicator, required: true },
  },
  fields: [{
    caption: 'TRADING DATE',
    dataType: 'string',
    dataField: 'tradingDate',
    area: 'row',
    expanded: true,
  }, {
    caption: 'TRADING HOUR',
    dataType: 'string',
    dataField: 'tradingHour',
    area: 'column',
    expanded: true,
    // }, {
    //   caption: 'MARKET TYPE',
    //   dataType: 'string',
    //   dataField: 'marketType',
    //   area: 'row',
    //   expanded: true,
  }, {
    caption: 'BAA',
    dataType: 'string',
    dataField: 'baa',
    area: 'row',
    expanded: true,
  }, {
    caption: 'SNAPSHOT INDICATOR',
    dataType: 'string',
    dataField: 'snapshotIndicator',
    area: 'row',
    expanded: true,
  }, {
    caption: 'RAMP TYPE',
    dataType: 'string',
    dataField: 'rampType',
    area: 'row',
    expanded: true,
  }, {
    caption: 'TEST INDICATOR',
    dataType: 'string',
    dataField: 'testIndicator',
    area: 'row',
    expanded: true,
  }, {
    caption: 'DATA TYPE',
    dataField: 'dataType',
    area: 'row',
    expanded: true,
    sortingMethod(a, b) {
      return a.text.localeCompare(b.text);
    },
  }, {
    caption: 'VALUE',
    dataField: 'value',
    area: 'data',
    expanded: true,
  }],
  options: {
    exportExcel: true,
    filterRow: true,
    filterHeader: true,
  },
};